import { formatDate } from '@leland-dev/leland-ui-library';
import React from 'react';

import { LIBRARY_URL } from '../utils/constants';

import SanityImage from './image/SanityImage';

interface Props {
  article: CMSArticle;
  large?: boolean;
  className?: string;
}

const ArticleCard: React.FC<Props> = ({
  article: { title, subtitle, featuredImage, slug, _updatedAt },
  large,
  className,
}) => {
  return (
    <a
      className={`${className} flex ${
        large ? 'w-80 shrink-0 flex-col' : 'max-h-12 items-center'
      }`}
      href={`${LIBRARY_URL}/a/${slug}`}
      target="_blank"
      rel="noreferrer"
      id="article_card:view"
    >
      <SanityImage
        className={`shrink-0 rounded object-cover ${
          large ? 'h-40 w-80' : 'h-11 w-20'
        }`}
        image={featuredImage}
        alt={title}
        sizes={{ dflt: large ? '80rem' : '20rem' }}
      />
      <div
        className={`${large ? 'mt-6' : 'ml-4'} flex flex-col justify-center`}
      >
        <p
          className={`line-clamp-2 max-h-10 font-normal leading-5 ${
            large && 'text-lg'
          }`}
        >
          {title}
        </p>
        <p
          className={`text-xs font-normal text-leland-gray-light ${
            large ? 'mt-1' : 'mt-0.5'
          }`}
        >
          {formatDate(new Date(_updatedAt))}
        </p>
      </div>
      {large ? <p className="mt-3 line-clamp-3 leading-5">{subtitle}</p> : null}
    </a>
  );
};

export default ArticleCard;
